import { Tag, TagProps } from "@chakra-ui/react";
import { CoServicePlanImportStatus } from "../../../shared/schema/gql/graphql";

/** The template-literal form accepts the REST string union as well as the enum. */
export type Status = `${CoServicePlanImportStatus}`;

const TAGS: Record<Status, { label: string; colorScheme: TagProps["colorScheme"] }> = {
  QUEUED: { label: "Queued", colorScheme: "gray" },
  PROCESSING: { label: "Processing", colorScheme: "blue" },
  // Not a retry — `retry_count` is 0 for every case this covers (no authorization
  // yet, or deferred behind another cutover) and RETRYING is its own status. The
  // job's error text says which, and the drawer shows it.
  WAITING: { label: "Waiting to be scheduled", colorScheme: "orange" },
  RETRYING: { label: "Retrying", colorScheme: "orange" },
  // Queued behind a human, not behind a retry — worth its own wording, because
  // "waiting to retry" sends a coordinator looking for a fault that isn't there.
  BLOCKED_BY_REVIEW: { label: "Waiting for earlier review", colorScheme: "orange" },
  // The one status that asks the coordinator to do something.
  PENDING_APPROVAL: { label: "Pending approval", colorScheme: "purple" },
  DECLINED: { label: "Declined", colorScheme: "gray" },
  COMPLETED: { label: "Completed", colorScheme: "green" },
  COMPLETED_WITH_WARNINGS: { label: "Completed with warnings", colorScheme: "yellow" },
  NEEDS_REVIEW: { label: "Needs review", colorScheme: "red" },
};

export default function CoServicePlanImportStatusTag({ status }: { status: Status }) {
  const tag = TAGS[status];
  return <Tag colorScheme={tag.colorScheme}>{tag.label}</Tag>;
}
